import Controller from "./listFilter.controller";
import template from "./listFilter.html";

const listFilter = {
  template,
  controller: Controller,
  bindings: {
    activeFilters: "<",
    activeParams: "<",
    eventName: "<",
    dynamicFiltersEvents: "<",
  },
};

export default listFilter;



// WEBPACK FOOTER //
// ./src/components/listFilter/listFilter.component.js